<template>
    <div class="language-menu-wrapper">
        <ul class="language-menu-list">
            <li
                class="language-menu-item"
                v-for="menu in langs"
                :key="menu.lang"
                :class="{ 'language-menu-on': currentLang == menu.lang }"
                @click="langClick(menu)"
            >
                <div class="language-menu-status-wrapper">
                    <span v-show="menu.status" class="language-menu-status" :class="{ 'language-menu-online': 'online' == menu.status }">
                        {{ menu.statusLabel }}
                    </span>
                </div>
                <span class="language-menu-label">{{ $t(menu.i18nKey) }}</span>
            </li>
        </ul>
    </div>
</template>

<script>
import { quesSaveType } from "@/views/zhiji/js/common/constants.js";
import { throttle } from "@/views/zhiji/js/common/util.js";

export default {
    name: "LanguageMenu",
    data() {
        return {
            waitingSave: false,
            toLang: ""
        };
    },
    computed: {
        currentLang() {
            return this.getStorePorp("currentSynonym");
        },
        langs() {
            return this.getStorePorp("synonymQuestions");
        },
        isUpdating() {
            return this.getStorePorp("isUpdating");
        },
        defaultLang() {
            const defaultLang = this.$store.state.zhiji.gameState.defaultLang;
            return defaultLang ? defaultLang : "en";
        }
    },
    watch: {
        isUpdating(newVal) {
            if (newVal == "success" && this.waitingSave) {
                this.waitingSave = false;
                this.toLang = "";
            }
        }
    },
    mounted() {
        this.changeLanguage = throttle(() => this.langClickHandler(), 0, 800);
    },
    methods: {
        getStorePorp(propName) {
            return this.$store.state.zhiji.questionEdit[propName];
        },
        langClick(item) {
            this.currentItem = item;
            this.changeLanguage();
        },
        langClickHandler() {
            const item = this.currentItem;

            if (this.waitingSave || item.lang == this.currentLang) {
                return;
            }

            const currentLang = this.currentLang;
            const defaultLangItem = this.zhiji.genItemSearchHandler("lang")(this.langs, this.defaultLang);

            if (this.isDefaultLang(currentLang) && !defaultLangItem.status) {
                this.$store.dispatch("zhiji/showModal", {
                    type: "MessageModal",
                    data: {
                        type: "tip",
                        message: this.$t("zhiji.knowlege.quesEditModal.recomCreateEn", { lang: this.$t("zhiji.common." + this.defaultLang) })
                    }
                });
                return;
            }

            const isAnswerChanged = this.getStorePorp("hasChange");
            if (isAnswerChanged) {
                this.$store.dispatch("zhiji/showModal", {
                    type: "MessageModal",
                    data: {
                        type: "tip",
                        message: this.$t("zhiji.knowlege.quesEditModal.recomSaveToDraft"),
                        confirmText: this.$t("zhiji.common.yes"),
                        cancelText: this.$t("zhiji.common.no"),
                        cancel: () => {
                            this.$store.dispatch("zhiji/editQsUpdateLanguage", item.lang);
                        },
                        confirm: () => {
                            this.waitingSave = true;
                            this.toLang = item.lang;
                            this.$store.dispatch("zhiji/saveQuesEditor", { saveType: quesSaveType.DRAFT });
                        }
                    }
                });
                return;
            }

            this.$store.dispatch("zhiji/editQsUpdateLanguage", item.lang);
        },
        isDefaultLang(lang) {
            return this.defaultLang == lang;
        }
    }
};
</script>

<style lang="scss" scoped>
.language-menu-wrapper {
    font-size: 14px;
    background: #dfe8f0;
    overflow-y: auto;

    .language-menu-item {
        position: relative;
        padding: 0 8px 0 76px;
        height: 56px;
        line-height: 56px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        cursor: pointer;

        &:hover {
            color: #2ec2ff;
            background: #f2f7fb;
        }
    }

    .language-menu-on {
        color: #2ec2ff;
        background: #f2f7fb;
    }

    .language-menu-status-wrapper {
        width: 76px;
        font-size: 12px;
        position: absolute;
        top: 18px;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .language-menu-status {
        min-width: 52px;
        padding: 0 8px;
        box-sizing: border-box;
        text-align: center;
        height: 20px;
        line-height: 20px;
        background: rgba(255, 255, 255, 0.8);
        border-radius: 10px;
        color: #9b9ba3;
    }

    .language-menu-online {
        color: #00c972;
    }
}
</style>
